import Header from '../../components/Header';
import Content from '../../components/Content';
import Footer from '../../components/Footer';

import logo from '../../assets/header/logo.png';

import { Container } from './styles';

const NotFound = () => {
  return (
    <Container>
      <Header />
      <Content>
        <img src={logo} alt="Logo do Yoga CO." />
        <h1>Ops! Página não encontrada</h1>
      </Content>
      <Footer />
    </Container>
  );
};

export default NotFound;
